import { render } from "./AbsenceModal.vue?vue&type=template&id=073320ea&ts=true"
import script from "./AbsenceModal.vue?vue&type=script&lang=ts"
export * from "./AbsenceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__